/**
 * User: Shad
 * Date: 9/20/13
 */
"use strict";
var SoaModel = require('bunsen/models/SoaModel');
var ShipmentContent = SoaModel.extend();

module.exports = ShipmentContent;

var Backbone = require('dibs-backbone');
var Item = require('bunsen/models/inventory/Item');
var _ = require('underscore');

/**
 * @class ShipmentContent
 * @extends SoaModel
 * @property {array} relations
 *      @property relations.type {Backbone.One}
 *      @property relations.key {string}- "item"
 *      @property relations.relatedModel {Backbone.Model}
 *      @property relations.collectionType {Backbone.Models}
 */
_.extend(ShipmentContent.prototype, {
    relations : SoaModel.createRelations([
        {
            type: Backbone.One,
            key: 'item',
            relatedModel: Item,
            saveJSONFields : ['id', 'apiType', 'vertical']
        }
    ])
});


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/models/ecomm/ShipmentContent.js
// module id = 179
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56